export default __webpack_public_path__ + "static/media/a011-startup-3.79de72ea.svg";